import { statusColor } from '@/lib/chartPalette';

/**
 * Status colours come from chartPalette's reserved STATUS slots, and always
 * sit next to the label itself, never colour alone.
 */
export function StatusPill({ status }: { status: string | null }) {
  if (!status) {
    return <span className="text-muted-foreground">No subscription</span>;
  }

  return (
    <span className="inline-flex items-center gap-2 whitespace-nowrap">
      <span
        aria-hidden="true"
        className="h-2 w-2 shrink-0 rounded-full"
        style={{ backgroundColor: statusColor(status) }}
      />
      <span className="capitalize">{status.replace(/_/g, ' ')}</span>
    </span>
  );
}
